/**
 * English translations, keyed by the French source phrase.
 * GENERATED by scripts/i18n-build.cjs from scripts/i18n/*.json — edit those.
 */
export const EN: Record<string, string> = {
  " · CIN vérifiée": " · ID verified",
  " · non-fumeur": " · non-smoker",
  " · pas de prix": " · no price",
  "— coordonnées, prix, logo, lien, nom de réseau social. Une annonce dont une vidéo en contient sera": "— contact details, prices, logos, links or social media handles. A listing whose video contains any will be",
  ", s’il correspond à un compte.": ", if it matches an account.",
  ". Bedly ne voit jamais ces images.": ". Bedly never sees these images.",
  ". En production, aucun code n’est jamais renvoyé par l’API.": ". In production, the API never returns a code.",
  ". Les positions affichées sont approximatives à 300 m près.": ". Positions shown are approximate, within about 300 m.",
  ". Pensez à regarder dans les spams.": ". Remember to check your spam folder.",
  ". Tant qu’il n’est pas saisi, vous ne pouvez ni réserver ni publier.": ". Until you enter it, you can neither book nor publish.",
  "· chaque cercle couvre environ 300 m autour du logement — l’adresse exacte n’est communiquée qu’après réservation.": "· each circle covers about 300 m around the home — the exact address is only shared after booking.",
  "· cible": "· target",
  "· créé le": "· created on",
  "· hôte": "· host",
  "· KYC": "· KYC",
  "· payés en ligne, une seule fois": "· paid online, once",
  "· recadrée": "· cropped",
  "· RIB ••••": "· RIB ••••",
  "· une seule fois, à la réservation": "· once, when you book",
  "« {title} » — {neighborhood}, {city}": "“{title}” — {neighborhood}, {city}",
  "(avant le {date})": "(before {date})",
  "(exclu)": "(excluded)",
  "). Le loyer de": "). The rent of",
  "). Vous la voyez parce que vous en êtes l’hôte ou un administrateur.": "). You can see it because you are its host or an administrator.",
  "{count} annonce(s)": "{count} listing(s)",
  "{count} annonce(s) en ligne": "{count} listing(s) live",
  "{count} annonces en ligne": "{count} listings live",
  "{count} confirmées": "{count} confirmed",
  "{count} étoile(s)": "{count} star(s)",
  "{count} filtre(s)": "{count} filter(s)",
  "{count} j": "{count} d",
  "{count} logement(s)": "{count} home(s)",
  "{count} logements": "{count} homes",
  "{count} mois": "{count} month(s)",
  "{count} non lus": "{count} unread",
  "{count} nuit(s)": "{count} night(s)",
  "{count} nuit(s) bloquée(s), {taken} déjà prise(s).": "{count} night(s) blocked, {taken} already taken.",
  "{count} nuit(s) bloquée(s).": "{count} night(s) blocked.",
  "{count} nuit(s) libérée(s).": "{count} night(s) released.",
  "{count} personne(s)": "{count} person(s)",
  "{count} vérifiés": "{count} verified",
  "{count}/24 chiffres": "{count}/24 digits",
  "{kind} à {where} · à partir de {price}{unit}.": "{kind} in {where} · from {price}{unit}.",
  "{kind} à {where}.": "{kind} in {where}.",
  "{max} photos — le maximum": "{max} photos — the maximum",
  "{max} photos maximum : les {count} dernières n’ont pas été ajoutées.": "{max} photos maximum: the last {count} were not added.",
  "{max} vidéos — le maximum": "{max} videos — the maximum",
  "{minutes} min à pied du campus": "{minutes} min walk from campus",
  "{name} a envoyé une pièce d’identité.": "{name} sent an ID document.",
  "{name} souhaite réserver {title}.": "{name} would like to book {title}.",
  "{percent} % des visiteurs demandent": "{percent}% of visitors send a request",
  "{what} à {city}": "{what} in {city}",
  "{what} à {city} : annonces visitées par Bedly, hôtes vérifiés, prix tout compris. Vous ne payez en ligne que les frais Bedly, le loyer se règle en main propre.": "{what} in {city}: listings visited by Bedly, verified hosts, all-inclusive prices. You only pay the Bedly fee online, the rent is paid in person.",
  "{what} au Maroc": "{what} in Morocco",
  "@bedly.ma": "@bedly.ma",
  "/mois": "/month",
  "/nuit": "/night",
  "← Mes réservations": "← My bookings",
  "← Quitter": "← Leave",
  "← Retour à l’annonce": "← Back to the listing",
  "← Retour aux résultats": "← Back to results",
  "← Tableau de bord": "← Dashboard",
  "+ Ajouter des photos ({count}/{max})": "+ Add photos ({count}/{max})",
  "+ Ajouter une chambre": "+ Add a room",
  "+ Ajouter une photo": "+ Add a photo",
  "+ Ajouter une vidéo ({count}/{max})": "+ Add a video ({count}/{max})",
  "+ Nouvelle annonce": "+ New listing",
  "+ Publier ma demande": "+ Post my request",
  "+ Publier une nouvelle demande": "+ Post a new request",
  "×": "×",
  "★ Couverture": "★ Cover",
  "♡ Enregistrer": "♡ Save",
  "♥ Enregistrée": "♥ Saved",
  "1 an": "1 year",
  "10 mois (année universitaire)": "10 months (academic year)",
  "12 % par séjour confirmé pour les nuitées": "12% per confirmed stay for nightly rentals",
  "12, rue Jbel Bouiblane": "12, rue Jbel Bouiblane",
  "30 derniers jours": "Last 30 days",
  "6 caractères minimum.": "At least 6 characters.",
  "8 % du premier mois pour une location au mois ou en colocation": "8% of the first month for monthly rentals or flatshares",
  "8 caractères minimum, avec des lettres et des chiffres.": "At least 8 characters, with letters and numbers.",
  "8 caractères minimum, lettres et chiffres.": "At least 8 characters, letters and numbers.",
  "à encaisser en espèces": "to collect in cash",
  "à l'instant": "just now",
  "À la nuit": "Nightly",
  "À la remise des clés, directement à vous": "When the keys are handed over, directly to you",
  "À payer maintenant en ligne": "To pay online now",
  "À propos du logement": "About this home",
  "À remettre en espèces à l’hôte": "To hand to the host in cash",
  "À répondre avant le": "Reply before",
  "À traiter": "To handle",
  "À valider": "To review",
  "À venir": "Upcoming",
  "Acceptée — dépôt à régler": "Accepted — fee to pay",
  "Acceptée — frais de service à régler": "Accepted — service fee to pay",
  "Accepter": "Accept",
  "Acompte de 500 DH en ligne, le reste au check-in": "500 MAD deposit online, the rest at check-in",
  "Actif": "Active",
  "Activation…": "Activating…",
  "Active": "Active",
  "Activées sur cet appareil : demandes, réservations et messages arrivent même quand Bedly est fermé.": "On for this device: requests, bookings and messages arrive even when Bedly is closed.",
  "Activer les notifications": "Turn on notifications",
  "Activez au moins un mode de location avec un prix.": "Turn on at least one rental type with a price.",
  "Activez au moins un type de location avec un prix.": "Turn on at least one rental type with a price.",
  "Admin": "Admin",
  "Adresse": "Address",
  "Adresse :": "Address:",
  "Adresse exacte": "Exact address",
  "Adresse exacte :": "Exact address:",
  "Adresse introuvable — voici le centre de la ville": "Address not found — here is the city centre",
  "Adresse introuvable. Placez le point à la main.": "Address not found. Place the pin by hand.",
  "Adresse précise": "Exact address",
  "Afficher le mot de passe": "Show password",
  "Afficher plus": "Show more",
  "Affilié créé — code {code}": "Affiliate created — code {code}",
  "Affilié mis en pause": "Affiliate paused",
  "Affilié réactivé": "Affiliate reactivated",
  "Affiliés": "Affiliates",
  "Agadir": "Agadir",
  "Agdal": "Agdal",
  "Agdal, Hassan…": "Agdal, Hassan…",
  "Agdal, studio, proche tram…": "Agdal, studio, near the tram…",
  "Ajouter": "Add",
  "Ajoutez au moins {count} photos.": "Add at least {count} photos.",
  "Ajoutez des photos": "Add photos",
  "Ajoutez une chambre pour la louer indépendamment. Réserver le logement entier bloque automatiquement toutes les chambres, et inversement.": "Add a room to rent it separately. Booking the whole home automatically blocks every room, and vice versa.",
  "Al Akhawayn University": "Al Akhawayn University",
  "Alerte activée": "Alert on",
  "Annonce à corriger": "Listing needs changes",
  "Annonce à valider": "Listing to approve",
  "Annonce approuvée et mise en ligne.": "Listing approved and published.",
  "Annonce en ligne": "Listing live",
  "Annonce enregistrée.": "Listing saved.",
  "Annonce envoyée !": "Listing submitted!",
  "Annonce envoyée pour vérification.": "Listing sent for review.",
  "Annonce introuvable": "Listing not found",
  "Annonce mise à jour.": "Listing updated.",
  "Annonce mise en pause.": "Listing paused.",
  "Annonce renvoyée en brouillon.": "Listing sent back to draft.",
  "Annonce supprimée.": "Listing deleted.",
  "Annonces": "Listings",
  "Annonces à {city} visitées par Bedly, hôtes vérifiés, prix tout compris.": "Listings in {city} visited by Bedly, verified hosts, all-inclusive prices.",
  "Annonces à vérifier": "Listings to review",
  "Annonces de colocation publiées par des étudiants : chambre libre, budget, quartier et campus. Répondez directement, sans intermédiaire et sans frais de dossier.": "Flatshare requests posted by students: free room, budget, neighbourhood and campus. Reply directly, with no middleman and no application fee.",
  "annonces en attente": "listings waiting",
  "Annonces en ligne": "Live listings",
  "Annonces en ligne par ville": "Live listings by city",
  "Annonces publiées": "Listings published",
  "Annonces récentes": "Recent listings",
  "Annulation par l’hôte ou Bedly": "Cancelled by the host or Bedly",
  "Annulée": "Cancelled",
  "Annuler": "Cancel",
  "Annuler la réservation": "Cancel the booking",
  "Aperçu": "Preview",
  "Aperçu de votre annonce": "Preview of your listing",
  "Aperçu public": "Public preview",
  "Apparence": "Appearance",
  "Appartement ou maison rien que pour le locataire": "A flat or house just for the tenant",
  "approuvée": "approved",
  "Approuver": "Approve",
  "Arrivée": "Check-in",
  "Ascenseur": "Lift",
  "Attijariwafa Bank": "Attijariwafa Bank",
  "Au moins {n} caractères.": "At least {n} characters.",
  "Au moins {n} éléments.": "At least {n} items.",
  "Au moins 8 caractères.": "At least 8 characters.",
  "Au mois": "Monthly",
  "Au plus {n} caractères.": "At most {n} characters.",
  "Au plus {n} éléments.": "At most {n} items.",
  "Aucun affilié pour l’instant": "No affiliates yet",
  "Aucun appareil n’a reçu la notification.": "No device received the notification.",
  "Aucun avis publié pour le moment.": "No reviews published yet.",
  "Aucun code en attente pour cette adresse. Demandez-en un nouveau.": "No code is waiting for this address. Ask for a new one.",
  "Aucun frais n’a encore été encaissé : rien à rembourser.": "No fee has been collected yet: nothing to refund.",
  "aucun numéro de téléphone ni aucun texte": "no phone number and no text",
  "Aucun prix défini": "No price set",
  "Aucun résultat": "No results",
  "Aucun résultat.": "No results.",
  "Aucun signalement ouvert": "No open reports",
  "Aucune annonce": "No listings",
  "Aucune annonce en attente": "No listings waiting",
  "Aucune annonce en ligne pour le moment": "No listings online yet",
  "Aucune annonce enregistrée": "No saved listings",
  "Aucune chambre séparée. Ajoutez-en une pour la louer indépendamment du logement entier.": "No separate rooms. Add one to rent it independently of the whole home.",
  "Aucune conversation": "No conversations",
  "Aucune demande": "No requests",
  "Aucune demande de colocation": "No flatshare requests",
  "Aucune demande en attente : tout est à jour.": "No requests waiting: you're all caught up.",
  "Aucune demande trouvée": "No requests found",
  "Aucune identité en attente": "No identities waiting",
  "Aucune image de document n’est stockée par Bedly. Ouvrez le dossier chez le prestataire avec la référence ci-dessous.": "Bedly stores no document images. Open the file at the provider using the reference below.",
  "Aucune notification": "No notifications",
  "Aucune photo": "No photo",
  "Aucune réservation": "No bookings",
  "Aucune université": "No university",
  "Auteurs et licences des photos des villes sur Bedly.": "Authors and licences of the city photos on Bedly.",
  "Autres photos": "More photos",
  "Avant de publier :": "Before publishing:",
  "Avis": "Reviews",
  "Avis reçus": "Reviews received",
  "Badge « Visité » après le passage de notre équipe, sous 48 h": "“Visited” badge once our team has been, within 48 h",
  "Balcon": "Balcony",
  "Banque (optionnel)": "Bank (optional)",
  "Bedly": "Bedly",
  "Bedly n’encaisse que ses frais de service (": "Bedly only collects its service fee (",
  "Bedly ne perçoit que ses frais de service : le loyer est réglé directement à l’hôte, en espèces, lorsque vous vous rencontrez. Annulation :": "Bedly only charges its service fee: the rent is paid directly to the host, in cash, when you meet. Cancellation:",
  "Bedly ne perçoit que ses frais de service, payés en ligne au moment de la réservation. Le loyer se règle en espèces directement à l’hôte, lors de la remise des clés.": "Bedly only charges its service fee, paid online when you book. The rent is paid in cash directly to the host when the keys are handed over.",
  "Bedly ouvre dans": "Bedly is opening in",
  "Bedly sur Instagram (@bedly.ma)": "Bedly on Instagram (@bedly.ma)",
  "Bedly vient d’ouvrir. Les premières chambres et colocations arrivent — et si vous avez un logement à louer, vous pouvez être le premier à publier.": "Bedly has just opened. The first rooms and flatshares are on their way — and if you have a place to rent, you can be the first to publish.",
  "Bedly, accueil": "Bedly, home",
  "Bénéficiaire": "Beneficiary",
  "Benguerir": "Benguerir",
  "Bienvenue chez les hôtes": "Welcome to hosting",
  "Bienvenue chez les hôtes.": "Welcome to hosting.",
  "Bienvenue sur Bedly": "Welcome to Bedly",
  "Bienvenue, {name} !": "Welcome, {name}!",
  "Bio": "Bio",
  "Bloqué": "Blocked",
  "Bloquer": "Block",
  "Bloquer des dates": "Block dates",
  "Bon retour !": "Welcome back!",
  "Bon retour, {name} !": "Welcome back, {name}!",
  "Brouillon": "Draft",
  "Budget max (DH)": "Max budget (MAD)",
  "Budget max (DH/mois)": "Max budget (MAD/month)",
  "Budget max (DH/nuit)": "Max budget (MAD/night)",
  "Budget min (DH/mois)": "Min budget (MAD/month)",
  "Bureau d’étude": "Study desk",
  "C’est noté : vous serez alerté dès qu’un logement arrive à {city}.": "Done: you'll be told as soon as a place comes up in {city}.",
  "C’est votre propre demande.": "This is your own request.",
  "Calcul des statistiques…": "Calculating statistics…",
  "Calcul du prix…": "Calculating the price…",
  "Calcul du remboursement…": "Calculating the refund…",
  "Calendrier": "Calendar",
  "Carte": "Map",
  "Carte bancaire (CMI)": "Bank card (CMI)",
  "Carte de séjour": "Residence permit",
  "Casablanca": "Casablanca",
  "Ce code a expiré — demandez-en un nouveau.": "This code has expired — ask for a new one.",
  "Ce code affilié n’existe pas ou n’est plus actif": "This affiliate code doesn't exist or is no longer active",
  "Ce code est déjà pris.": "That code is already taken.",
  "Ce code n’est pas correct.": "That code isn't right.",
  "Ce compte est suspendu.": "This account is suspended.",
  "Ce compte n’est pas actif.": "This account is not active.",
  "Ce compte n’existe plus.": "This account no longer exists.",
  "Ce compte ne peut pas envoyer de messages.": "This account can't send messages.",
  "Ce fichier est une image, pas une vidéo.": "That file is an image, not a video.",
  "Ce fichier n’est pas une image JPEG, PNG, WebP ou AVIF.": "That file isn't a JPEG, PNG, WebP or AVIF image.",
  "Ce fichier n’est pas une vidéo MP4, MOV ou WebM.": "That file isn't an MP4, MOV or WebM video.",
  "Ce lien de réinitialisation a expiré.": "This reset link has expired.",
  "Ce lien de réinitialisation n’est pas valide.": "This reset link isn't valid.",
  "Ce logement accueille au plus {count} personne(s).": "This place takes at most {count} guest(s).",
  "Ce logement n’accepte pas de réservations pour le moment.": "This place isn't taking bookings right now.",
  "Ce logement n’est pas proposé pour ce type de séjour.": "This place isn't offered for this type of stay.",
  "Ce logement ne vous appartient pas.": "This place isn't yours.",
  "Ce navigateur ne permet pas les notifications. Essayez Chrome, Edge, Firefox ou Safari à jour.": "This browser doesn't support notifications. Try an up-to-date Chrome, Edge, Firefox or Safari.",
  "Ce numéro appartient déjà à un autre compte.": "This number already belongs to another account.",
  "Ce point est hors du Maroc.": "That pin is outside Morocco.",
  "Centre-ville — déplacez le point": "City centre — move the pin",
  "Certains champs sont invalides.": "Some fields are invalid.",
  "Ces dates ne sont pas disponibles.": "Those dates aren't available.",
  "Ces dates ne sont plus disponibles. Essayez d’autres dates.": "These dates are no longer available. Try other dates.",
  "Ces dates viennent d’être prises pour ce logement.": "Those dates have just been taken for this place.",
  "Ces frais ont déjà été réglés.": "This fee has already been paid.",
  "Cet élément ne vous appartient pas.": "This isn't yours.",
  "Cette action n’est plus possible.": "This action is no longer possible.",
  "Cette annonce a des réservations en cours — mettez-la en pause au lieu de la supprimer.": "This listing has ongoing bookings — pause it instead of deleting it.",
  "Cette annonce a été supprimée.": "This listing was deleted.",
  "Cette annonce est déjà en ligne.": "This listing is already live.",
  "Cette annonce n’est pas encore prête à être publiée.": "This listing isn't ready to publish yet.",
  "Cette annonce n’est pas publique (": "This listing is not public (",
  "Cette chambre a des réservations en cours.": "This room has ongoing bookings.",
  "Cette chambre ne vous appartient pas.": "This room isn't yours.",
  "Cette conversation ne vous appartient pas.": "This conversation isn't yours.",
  "Cette demande ne vous appartient pas.": "This request isn't yours.",
  "Cette photo ne vous appartient pas.": "This photo isn't yours.",
  "Cette réservation est déjà confirmée.": "This booking is already confirmed.",
  "Cette réservation est introuvable.": "This booking could not be found.",
  "Cette réservation n’a rien à payer en ligne.": "This booking has nothing to pay online.",
  "Cette réservation ne peut plus changer de statut.": "This booking can no longer change status.",
  "Cette réservation ne vous appartient pas.": "This booking isn't yours.",
  "Cette valeur est déjà utilisée.": "This value is already in use.",
  "Cette vérification a déjà été traitée.": "This verification has already been handled.",
  "chambre": "room",
  "Chambre": "Room",
  "Chambre {number}": "Room {number}",
  "Chambre au mois": "Monthly room",
  "Chambre lumineuse dans un appartement calme, à dix minutes à pied du campus…": "Bright room in a quiet flat, ten minutes' walk from campus…",
  "Chambre meublée": "Furnished room",
  "Chambre meublée à Agdal, 10 min de l’UM5": "Furnished room in Agdal, 10 min from UM5",
  "Chambre partagée": "Shared room",
  "Chambre privée": "Private room",
  "Chambre supprimée.": "Room deleted.",
  "Chambre sur cour": "Courtyard room",
  "chambre(s)": "room(s)",
  "chambre(s) ·": "room(s) ·",
  "Chambres": "Bedrooms",
  "Chambres à louer séparément (optionnel)": "Rooms to rent separately (optional)",
  "Chambres au mois": "Monthly rooms",
  "Champ obligatoire.": "Required field.",
  "Changer d’adresse demande de vérifier la nouvelle avec un code.": "Changing your address means verifying the new one with a code.",
  "Changer le mot de passe": "Change password",
  "Changer le mot de passe déconnecte tous vos appareils. C’est voulu.": "Changing your password signs out all your devices. That is intentional.",
  "Chaque hôte est identifié par sa carte nationale avant publication.": "Every host is identified with their national ID card before publishing.",
  "Chargement de Google…": "Loading Google…",
  "Chargement de l’annonce…": "Loading the listing…",
  "Chargement de l’espace admin…": "Loading the admin area…",
  "Chargement de la messagerie…": "Loading messages…",
  "Chargement de votre session…": "Loading your session…",
  "Chargement des annonces…": "Loading listings…",
  "Chargement des demandes…": "Loading requests…",
  "Chargement du tableau de bord…": "Loading the dashboard…",
  "Chargement…": "Loading…",
  "Charges incluses · sans frais cachés": "Bills included · no hidden fees",
  "Chauffage": "Heating",
  "Chercher une colocation": "Find a flatshare",
  "Choisissez au moins un type de location.": "Choose at least one rental type.",
  "Choisissez un fichier.": "Choose a file.",
  "Choisissez une valeur de la liste.": "Choose a value from the list.",
  "Cible de téléversement": "Upload target",
  "CIN déjà vérifiée — rien à renvoyer.": "ID already verified — nothing to send again.",
  "CIN vérifiée": "ID verified",
  "Climatisation": "Air conditioning",
  "Club étudiant UM5, @influenceuse…": "UM5 student club, @influencer…",
  "CNIE — carte nationale électronique": "CNIE — electronic national ID card",
  "Code": "Code",
  "Code (optionnel)": "Code (optional)",
  "Code à 6 chiffres": "6-digit code",
  "Code à 6 chiffres envoyé à": "6-digit code sent to",
  "Code affilié (optionnel)": "Affiliate code (optional)",
  "Code d’affiliation inconnu.": "Unknown affiliate code.",
  "Code de paiement en agence": "Agency payment code",
  "Code de vérification": "Verification code",
  "Code envoyé à": "Code sent to",
  "Coloc": "Flatshare",
  "coloc ·": "flatshare ·",
  "coloc recherché(s)": "flatmate(s) wanted",
  "Colocataires recherchés": "Flatmates wanted",
  "Colocation": "Flatshare",
  "Colocation (chambres partagées entre locataires)": "Flatshare (rooms shared between tenants)",
  "Colocations": "Flatshares",
  "Colocations entre étudiants au Maroc": "Student flatshares in Morocco",
  "Colocations, chambres au mois et locations au Maroc.": "Flatshares, monthly rooms and rentals in Morocco.",
  "Colocations, chambres au mois et nuitées.": "Flatshares, monthly rooms and nightly stays.",
  "Colocations, chambres au mois et séjours à la nuit — hôtes vérifiés, logements visités. Vous ne payez en ligne que les frais de service ; le loyer se règle en main propre.": "Flatshares, monthly rooms and nightly stays — verified hosts, visited homes. You only pay the service fee online; the rent is paid in person.",
  "Colocations, chambres et locations": "Flatshares, rooms and rentals",
  "Colocations, chambres et locations au Maroc": "Flatshares, rooms and rentals in Morocco",
  "Colocations, chambres étudiantes au mois et locations à la nuit partout au Maroc. Annonces visitées par Bedly, hôtes vérifiés, réservation en ligne : vous ne payez en ligne que les frais Bedly, le loyer se règle en main propre.": "Flatshares, monthly student rooms and nightly rentals across Morocco. Listings visited by Bedly, verified hosts, online booking: you only pay the Bedly fee online, the rent is paid in person.",
  "Commencer la vérification": "Start verification",
  "Commencez une conversation depuis une annonce ou une demande de colocation.": "Start a conversation from a listing or a flatshare request.",
  "Comment louez-vous ?": "How do you rent it out?",
  "Comment réglez-vous les frais de service ?": "How will you pay the service fee?",
  "Communiquée au locataire une fois la réservation confirmée.": "Shared with the tenant once the booking is confirmed.",
  "Compte": "Account",
  "Compte réactivé.": "Account reactivated.",
  "Compte supprimé.": "Account deleted.",
  "Compte suspendu.": "Account suspended.",
  "Concierge": "Concierge",
  "Conditions, contact, commission convenue…": "Terms, contact, agreed commission…",
  "Confirmée": "Confirmed",
  "confirmées": "confirmed",
  "Confirmées": "Confirmed",
  "confirmées au total": "confirmed in total",
  "Confirmer l’annulation": "Confirm cancellation",
  "Confirmer le refus": "Confirm refusal",
  "Connectez-vous pour continuer.": "Sign in to continue.",
  "Connectez-vous pour retrouver vos réservations.": "Sign in to see your bookings.",
  "Connexion": "Sign in",
  "Connexion…": "Signing in…",
  "Contacter l’hôte": "Contact the host",
  "Continuer": "Continue",
  "Conversation introuvable": "Conversation not found",
  "Conversion": "Conversion",
  "Coordonnées": "Contact details",
  "Coordonnées de versement": "Payout details",
  "Copié": "Copied",
  "Copier": "Copy",
  "courtes vidéos pour faire visiter le logement —": "short videos to show the home —",
  "Couverture": "Cover",
  "Création…": "Creating…",
  "crédits": "credits",
  "Crédits photos": "Photo credits",
  "Créer l’affilié": "Create affiliate",
  "Créer mon compte": "Create my account",
  "Créer un compte": "Sign up",
  "Créer un compte pour publier": "Sign up to publish",
  "Créer une annonce": "Create a listing",
  "Créez un code pour un partenaire : chaque inscription faite avec lui sera suivie ici.": "Create a code for a partner: every signup made with it will be tracked here.",
  "Croissance des membres": "Member growth",
  "Cuisine": "Kitchen",
  "Cuisine équipée": "Equipped kitchen",
  "Date d’emménagement": "Move-in date",
  "Date de naissance": "Date of birth",
  "date inconnue": "unknown date",
  "Date invalide.": "Invalid date.",
  "Dates": "Dates",
  "Débloquer": "Unblock",
  "Décision de modération": "Moderation decision",
  "Déconnecté de tous les appareils.": "Signed out of all devices.",
  "Déjà un compte ?": "Already have an account?",
  "demande → réservation": "request → booking",
  "Demande acceptée": "Request accepted",
  "Demande acceptée.": "Request accepted.",
  "Demande acceptée. Le locataire peut régler les frais de service.": "Request accepted. The tenant can now pay the service fee.",
  "Demande envoyée": "Request sent",
  "Demande envoyée à l’hôte.": "Request sent to the host.",
  "Demande expirée": "Request expired",
  "Demande introuvable": "Request not found",
  "Demande mise à jour.": "Request updated.",
  "Demande publiée. Les hôtes et colocataires peuvent vous écrire.": "Request posted. Hosts and flatmates can now write to you.",
  "Demande refusée": "Request declined",
  "Demande refusée.": "Request declined.",
  "Demande refusée. Les dates sont libérées.": "Request declined. The dates are free again.",
  "Demande supprimée.": "Request deleted.",
  "demande(s)": "request(s)",
  "Demandes": "Requests",
  "Demandes de colocation": "Flatshare requests",
  "Demandes en attente": "Pending requests",
  "Demandes par type": "Requests by type",
  "Demandes récentes": "Recent requests",
  "Demandez au plus {count} nuits à la fois.": "Ask for at most {count} nights at a time.",
  "Départ": "Check-out",
  "depuis le lancement": "since launch",
  "Des corrections sont nécessaires avant publication.": "Some changes are needed before publishing.",
  "des inscrits de la période": "of this period's signups",
  "Désactiver sur cet appareil": "Turn off on this device",
  "Description": "Description",
  "Détail du prix": "Price breakdown",
  "Détails": "Details",
  "Deux lignes pour vous présenter aux hôtes.": "Two lines to introduce yourself to hosts.",
  "Devenez hôte en trois étapes. Publication gratuite.": "Become a host in three steps. Publishing is free.",
  "Devenir hôte": "Become a host",
  "DH / mois": "MAD / month",
  "DH / nuit": "MAD / night",
  "Dim": "Sun",
  "Disponible": "Available",
  "Disponible du": "Available from",
  "Document": "Document",
  "Doit être au moins {n}.": "Must be at least {n}.",
  "Doit être au plus {n}.": "Must be at most {n}.",
  "Doit être inférieur à {n}.": "Must be less than {n}.",
  "Doit être supérieur à {n}.": "Must be greater than {n}.",
  "Donnez un titre à votre annonce.": "Give your listing a title.",
  "Du": "From",
  "Durée": "Length",
  "Durée du bail": "Lease length",
  "Eau chaude": "Hot water",
  "Écrire mon avis": "Write my review",
  "Écrivez à un hôte depuis une annonce, ou répondez à une demande de colocation.": "Write to a host from a listing, or reply to a flatshare request.",
  "Écrivez votre message…": "Write your message…",
  "El Jadida": "El Jadida",
  "Élargissez le budget ou changez de ville.": "Widen your budget or change city.",
  "Elle a peut-être été retirée ou mise en pause par son hôte.": "It may have been removed or paused by its host.",
  "Elle sera en ligne après la visite de vérification Bedly, sous 48 h. Vous pouvez déjà la modifier depuis votre tableau de bord.": "It will go live after Bedly's verification visit, within 48 h. You can already edit it from your dashboard.",
  "Email": "Email",
  "Email :": "Email:",
  "Email non vérifié": "Email not verified",
  "Email ou téléphone": "Email or phone",
  "Email vérifié": "Email verified",
  "Email vérifié. Bienvenue sur Bedly.": "Email verified. Welcome to Bedly.",
  "Email, téléphone ou mot de passe incorrect.": "Email, phone or password is incorrect.",
  "Emails vérifiés": "Verified emails",
  "Emménagement": "Move-in",
  "En attente de la réponse de l’hôte. Vous pourrez régler les frais de service dès qu’il accepte — vous recevrez une notification.": "Waiting for the host's answer. You can pay the service fee as soon as they accept — you will get a notification.",
  "En attente de visite": "Awaiting visit",
  "En configuration locale le prestataire est notre propre file de modération : un administrateur validera depuis l’espace admin.": "In local setup the provider is our own moderation queue: an administrator will approve from the admin area.",
  "En continuant vous acceptez les conditions d’utilisation et la politique de confidentialité de Bedly.": "By continuing you accept Bedly's terms of use and privacy policy.",
  "En cours de vérification": "Being verified",
  "En cours ou à venir": "Ongoing or upcoming",
  "en espèces": "in cash",
  "En espèces, à l’hôte, à la remise des clés": "In cash, to the host, when the keys are handed over",
  "En espèces, à la remise des clés, sans commission": "In cash, when you hand over the keys, no commission",
  "En ligne": "Live",
  "En pause": "Paused",
  "English": "English",
  "Enregistrées": "Saved",
  "Enregistrement…": "Saving…",
  "Enregistrer": "Save",
  "Enregistrer le RIB": "Save bank details",
  "ENSA Kénitra": "ENSA Kenitra",
  "Entre": "Between",
  "Entre 7 jours et 48 h": "Between 7 days and 48 h",
  "Entrez le code reçu": "Enter the code you received",
  "Entrez une adresse email valide.": "Enter a valid email address.",
  "Entrez votre mot de passe.": "Enter your password.",
  "Envoi de la vidéo…": "Uploading the video…",
  "Envoi…": "Sending…",
  "Envoyé": "Sent",
  "Envoyé à": "Sent to",
  "Envoyée pour vérification. Visite sous 48 h.": "Sent for review. Visit within 48 h.",
  "Envoyer": "Send",
  "Envoyer la demande": "Send the request",
  "Envoyer le code": "Send the code",
  "Envoyer mon avis": "Send my review",
  "Envoyer pour vérification": "Send for review",
  "Envoyer un test": "Send a test",
  "Envoyer vos documents": "Send your documents",
  "Envoyez le recto, le verso et un selfie au prestataire via le lien ci-dessous. Ce lien expire le": "Send the front, the back and a selfie to the provider through the link below. This link expires on",
  "Équipements": "Amenities",
  "Espace administrateur": "Admin area",
  "Espèces": "Cash",
  "Espèces à l’arrivée + acompte": "Cash on arrival + deposit",
  "Essayez d’élargir votre budget, de changer de ville ou de retirer quelques filtres.": "Try widening your budget, changing city or removing a few filters.",
  "Est-ce toujours disponible ?": "Is it still available?",
  "Étape": "Step",
  "Être alerté quand un logement arrive": "Tell me when a place comes up",
  "Étudiante en médecine à l’UM5, calme et organisée, non-fumeuse…": "Medical student at UM5, calm and organised, non-smoker…",
  "Étudiants et jeunes actifs qui cherchent des colocataires.": "Students and young professionals looking for flatmates.",
  "Ex : 2 500 DH": "E.g. 2,500 DH",
  "Ex : 400 DH": "E.g. 400 DH",
  "Exactement comme sur votre pièce d’identité.": "Exactly as on your ID document.",
  "Exécuter maintenant": "Run now",
  "Exécution…": "Running…",
  "Expirée": "Expired",
  "Expirer les demandes sans réponse, clôturer les séjours terminés, publier les avis dus après 14 jours, expirer les demandes de colocation dépassées. Le planificateur fait la même chose toutes les 5 minutes ; ce bouton la déclenche maintenant.": "Expire unanswered requests, close finished stays, publish reviews due after 14 days, expire outdated flatshare requests. The scheduler does this every 5 minutes; this button runs it now.",
  "Explorer": "Explore",
  "Explorer les logements": "Explore homes",
  "Explorer par ville": "Explore by city",
  "Faites glisser le repère — ou touchez la carte — jusqu’à la porte du logement. Position exacte, visible de vous seul : sur la carte publique, les locataires verront une zone d’environ 300 m autour de ce point.": "Drag the pin — or tap the map — to the door of the home. Exact position, visible only to you: on the public map, tenants will see an area of about 300 m around this point.",
  "Faites vérifier votre identité avant de publier.": "Get your identity verified before publishing.",
  "Femmes uniquement": "Women only",
  "Fermer": "Close",
  "Fermer le menu": "Close the menu",
  "Fès": "Fez",
  "Fichier trop lourd.": "File too large.",
  "Fin le {date}": "Ends on {date}",
  "Force majeure": "Force majeure",
  "Format de fichier non pris en charge.": "File format not supported.",
  "Format invalide.": "Invalid format.",
  "Frais Bedly (": "Bedly fee (",
  "Frais Bedly encaissés": "Bedly fees collected",
  "Frais Bedly inclus · loyer en main propre": "Bedly fee included · rent paid in person",
  "Frais de service Bedly": "Bedly service fee",
  "Frais de service Bedly (": "Bedly service fee (",
  "frais en ligne": "online fee",
  "Frais encaissés": "Fees collected",
  "Frais générés": "Fees generated",
  "Français": "Français",
  "Généré si vide": "Generated if empty",
  "Gérer": "Manage",
  "Gérer mon annonce": "Manage my listing",
  "Google n’a pas fourni d’adresse email.": "Google didn't provide an email address.",
  "Historique": "History",
  "Hommes uniquement": "Men only",
  "Hôte": "Host",
  "Hôte :": "Host:",
  "Hôte vérifié": "Verified host",
  "Hôtes": "Hosts",
  "Hôtes vérifiés": "Verified hosts",
  "Identité": "Identity",
  "Identité :": "Identity:",
  "Identité à vérifier": "Identity to check",
  "Identité approuvée.": "Identity approved.",
  "Identité non vérifiée": "Identity not verified",
  "Identité refusée.": "Identity rejected.",
  "Identité vérifiée": "Identity verified",
  "Identité vérifiée. Le badge « Vérifié » apparaît sur votre profil et vos annonces.": "Identity verified. The “Verified” badge now shows on your profile and listings.",
  "Identités": "Identities",
  "Identités à valider": "Identities to verify",
  "Ifrane": "Ifrane",
  "Il manque": "Missing:",
  "il y a {count} h": "{count} h ago",
  "il y a {count} j": "{count} d ago",
  "il y a {count} min": "{count} min ago",
  "Image trop lourde : {max} Mo maximum.": "Image too large: {max} MB maximum.",
  "Important :": "Important:",
  "Impossible de calculer le prix": "Could not calculate the price",
  "Impossible de générer un code libre — réessayez.": "Couldn't generate a free code — try again.",
  "Indiquez l’adresse.": "Enter the address.",
  "Indiquez un email ou un numéro de téléphone.": "Enter an email or a phone number.",
  "Indiquez un prix pour activer ce type de location.": "Enter a price to turn on this rental type.",
  "Indiquez votre nom.": "Enter your name.",
  "Indisponible": "Unavailable",
  "Inscriptions": "Signups",
  "Inscriptions : méthode": "Signups: method",
  "Inscriptions : provenance": "Signups: source",
  "Inscrit le": "Joined on",
  "Inscrits": "Signups",
  "Instructions": "Instructions",
  "Instructions de paiement": "Payment instructions",
  "Instructions de paiement générées.": "Payment instructions generated.",
  "Interlocuteur": "Contact",
  "Introuvable : il a peut-être été supprimé.": "Not found: it may have been deleted.",
  "J’ai envoyé mes documents": "I have sent my documents",
  "J’autorise Bedly à traiter ces données pour vérifier mon identité, conformément à sa politique de confidentialité et à la loi 09-08 sur la protection des données personnelles.": "I authorise Bedly to process this data to verify my identity, in accordance with its privacy policy and Law 09-08 on the protection of personal data.",
  "j)": "d)",
  "Jamais publique. Elle sert à placer le logement sur la carte, et n’est communiquée au locataire qu’une fois la réservation confirmée.": "Never public. It places the home on the map, and is only shared with the tenant once the booking is confirmed.",
  "Je cherche un logement": "I'm looking for a place",
  "Je propose un logement": "I have a place to rent",
  "Jeu": "Thu",
  "Jusqu’à": "Up to",
  "Kénitra": "Kenitra",
  "L’adresse exacte est communiquée une fois la réservation confirmée — une protection pour l’hôte comme pour vous.": "The exact address is shared once the booking is confirmed — a protection for the host and for you.",
  "L’adresse exacte s’affiche une fois les frais de service réglés.": "The exact address shows once the service fee is paid.",
  "L’adresse exacte se débloque dès que les frais de service sont réglés.": "The exact address unlocks as soon as the service fee is paid.",
  "L’adresse ou le point sur la carte est incorrect": "The address or map pin is wrong",
  "L’email n’a pas pu être envoyé. Réessayez dans un instant.": "The email couldn't be sent. Try again in a moment.",
  "L’hôte a 48 h pour répondre. Les dates sont réservées pendant ce délai.": "The host has 48 h to answer. The dates are held during that time.",
  "L’hôte n’a pas encore accepté cette demande.": "The host hasn't accepted this request yet.",
  "L’hôte n’a pas pu accepter votre demande.": "The host couldn't accept your request.",
  "L’hôte n’a pas répondu à temps pour « {title} ». Les dates sont de nouveau libres : vous pouvez réessayer ou chercher ailleurs.": "The host didn't reply in time for “{title}”. The dates are free again: you can try again or look elsewhere.",
  "La connexion Google n’a pas pu être vérifiée.": "The Google sign-in couldn't be verified.",
  "La connexion Google n’est pas disponible pour le moment.": "Google sign-in isn't available right now.",
  "La date de début est déjà passée.": "The start date has already passed.",
  "La date de fin doit être après la date de début.": "The end date must be after the start date.",
  "La durée maximale ne peut pas être plus courte que la minimale.": "The maximum stay can't be shorter than the minimum.",
  "La file est vide.": "The queue is empty.",
  "La position publiée est volontairement décalée d’environ 300 m. L’adresse précise n’est partagée qu’après confirmation de la réservation.": "The published position is deliberately offset by about 300 m. The precise address is only shared once the booking is confirmed.",
  "La recherche d’adresse a échoué": "The address search failed",
  "La réservation {reference} n’a pas été payée à temps ; les dates sont libérées.": "Booking {reference} wasn't paid in time; the dates are free again.",
  "La réservation a été annulée.": "The booking was cancelled.",
  "La réservation est confirmée dès réception du paiement. Vous recevrez une notification.": "The booking is confirmed as soon as payment is received. You will get a notification.",
  "La vérification d’identité est requise avant de publier une annonce.": "Identity verification is required before publishing a listing.",
  "La vérification d’identité est requise avant de publier. Vous pourrez préparer votre annonce en attendant la validation.": "Identity verification is required before publishing. You can prepare your listing while it is being approved.",
  "La vérification d’identité rassure les hôtes et devient obligatoire pour publier une annonce. Comptez deux minutes.": "Identity verification reassures hosts and is required to publish a listing. It takes about two minutes.",
  "La visite de vérification a été effectuée (active le badge « Visité »)": "The verification visit has been done (turns on the “Visited” badge)",
  "Laisser un avis": "Leave a review",
  "Laissez un avis — il sera publié quand les deux parties auront répondu.": "Leave a review — it will be published once both sides have replied.",
  "Laissez un avis sur votre locataire.": "Leave a review of your tenant.",
  "Langue": "Language",
  "Latitude": "Latitude",
  "Le badge Vérifié apparaît maintenant sur votre profil et vos annonces.": "The Verified badge now shows on your profile and listings.",
  "Le budget maximum ne peut pas être inférieur au minimum.": "The maximum budget can't be below the minimum.",
  "Le code compte 6 chiffres.": "The code is 6 digits.",
  "Le délai de paiement pour « {title} » est passé. Les dates ont été libérées.": "The payment deadline for “{title}” has passed. The dates have been released.",
  "Le dépôt du locataire a été reçu.": "The tenant's payment has been received.",
  "Le document a expiré": "The document has expired",
  "Le lien que vous avez suivi ne mène nulle part.": "The link you followed leads nowhere.",
  "Le locataire a réglé les frais de service : la réservation est confirmée.": "The tenant paid the service fee: the booking is confirmed.",
  "Le locataire voit": "The tenant sees",
  "Le logement correspondait-il à l’annonce ? L’hôte était-il réactif ?": "Did the home match the listing? Was the host responsive?",
  "Le logement ne correspond pas à la visite": "The place doesn't match the visit",
  "Le nom ne correspond pas au compte": "The name doesn't match the account",
  "Le paiement des frais pour {reference} n’a pas abouti. Rien n’a été débité ; vous pouvez réessayer avant l’expiration de la demande.": "The fee payment for {reference} didn't go through. Nothing was charged; you can try again before the request expires.",
  "Le prix minimum est supérieur au prix maximum.": "The minimum price is above the maximum price.",
  "Le prix ne correspond pas au logement": "The price doesn't match the place",
  "Le Registre de Commerce sera demandé par le prestataire.": "The provider will ask for the Trade Register.",
  "Le remboursement porte sur les frais de service. Plus de 7 jours avant : intégral. Entre 7 jours et 48 h : 50 %. Moins de 48 h : non remboursés.": "Refunds apply to the service fee. More than 7 days before: full. Between 7 days and 48 h: 50%. Less than 48 h: not refunded.",
  "Le selfie ne correspond pas au document": "The selfie doesn't match the document",
  "Les charges sont-elles incluses ?": "Are bills included?",
  "Les dates sont bloquées jusqu’à votre réponse": "The dates are held until you answer",
  "Les demandes de réservation apparaîtront ici dès que votre annonce sera en ligne.": "Booking requests will appear here as soon as your listing is live.",
  "Les deux avis sont maintenant visibles.": "Both reviews are now visible.",
  "Les deux avis sont publiés.": "Both reviews are published.",
  "Les disponibilités se gèrent depuis le calendrier de l’annonce, après publication.": "Availability is managed from the listing's calendar, after publishing.",
  "Les essentiels": "The essentials",
  "Les notifications ont été refusées pour Bedly.": "Notifications were refused for Bedly.",
  "Les notifications sont activées": "Notifications are on",
  "Les notifications sont bloquées pour Bedly dans ce navigateur. Autorisez-les dans les réglages du site (le cadenas à côté de l’adresse), puis rechargez la page.": "Notifications are blocked for Bedly in this browser. Allow them in the site settings (the padlock next to the address), then reload the page.",
  "Les photos contiennent du texte ou des numéros": "The photos contain text or numbers",
  "Les photos des villes proviennent de Wikimedia Commons, sous licences libres. Elles ont été recadrées et redimensionnées pour l’affichage. Merci à leurs auteurs.": "The city photos come from Wikimedia Commons, under free licences. They have been cropped and resized for display. Thanks to their authors.",
  "Les premières annonces arrivent": "The first listings are coming",
  "Les réponses des hôtes, les confirmations et les messages arrivent ici.": "Host answers, confirmations and messages arrive here.",
  "Les vues, demandes et revenus apparaîtront ici après la publication de votre première annonce.": "Views, requests and earnings will show here once your first listing is published.",
  "Lettres, chiffres, - ou _, de 3 à 32 caractères.": "Letters, digits, - or _, 3 to 32 characters.",
  "Licence :": "Licence:",
  "Lien d’inscription": "Signup link",
  "Liste": "List",
  "lit": "bed",
  "lit(s)": "bed(s)",
  "lit(s) ·": "bed(s) ·",
  "Lits": "Beds",
  "Localisation": "Location",
  "Localiser": "Locate",
  "Locataire": "Tenant",
  "Location à la nuit": "Nightly rental",
  "Location au mois": "Monthly rental",
  "Locations à la nuit": "Nightly rentals",
  "Logement": "Home",
  "Logement entier": "Entire home",
  "Logements visités": "Visited homes",
  "Longitude": "Longitude",
  "Loyer payé en main propre": "Rent paid in person",
  "Lun": "Mon",
  "Ma demande de colocation": "My flatshare request",
  "Machine à laver": "Washing machine",
  "Maintenance": "Maintenance",
  "Mar": "Tue",
  "Maroc": "Morocco",
  "Marrakech": "Marrakesh",
  "Masquer le mot de passe": "Hide password",
  "Masquer les filtres": "Hide filters",
  "Masquer les inscrits": "Hide signups",
  "Meilleurs affiliés (": "Top affiliates (",
  "Meknès": "Meknes",
  "Membre": "Member",
  "Membre depuis": "Member since",
  "Membres": "Members",
  "Menu": "Menu",
  "Menu du compte": "Account menu",
  "Mer": "Wed",
  "Mes demandes": "My requests",
  "Mes réservations": "My bookings",
  "Message": "Message",
  "Message à l’hôte (optionnel)": "Message to the host (optional)",
  "Message du locataire": "Tenant's message",
  "Message envoyé.": "Message sent.",
  "Messages": "Messages",
  "Messages échangés": "Messages exchanged",
  "Mettre en pause": "Pause",
  "Mettre en pause la retire des résultats sans supprimer vos données.": "Pausing removes it from results without deleting your data.",
  "Meublé": "Furnished",
  "Mixte": "Mixed",
  "Mo maximum chacune (environ une minute en 720p).": "MB maximum each (about a minute in 720p).",
  "Mode de location": "Rental type",
  "Mode développement : le code est": "Development mode: the code is",
  "Mode économe — actualisation toutes les 15 s": "Low-data mode — refreshing every 15 s",
  "Mode hôte": "Host mode",
  "Modifier": "Edit",
  "Modifier ma demande": "Edit my request",
  "Moins de 48 h": "Less than 48 h",
  "Moins de filtres": "Fewer filters",
  "mois ·": "months ·",
  "Mois min.": "Min. months",
  "Mois minimum": "Minimum months",
  "Mon compte": "My account",
  "Montants en dirhams (MAD), taxes incluses.": "Amounts in dirhams (MAD), taxes included.",
  "Mot de passe": "Password",
  "Mot de passe actuel": "Current password",
  "Mot de passe modifié. Connectez-vous.": "Password changed. Please sign in.",
  "Mot de passe modifié. Reconnectez-vous.": "Password changed. Please sign in again.",
  "Mot de passe oublié": "Forgotten password",
  "Mot de passe oublié ?": "Forgot your password?",
  "Motif (optionnel)": "Reason (optional)",
  "Motif du refus (envoyé à la personne)": "Reason for refusal (sent to the person)",
  "Naissance": "Birth",
  "Nationalité": "Nationality",
  "Navigation": "Navigation",
  "Navigation principale": "Main navigation",
  "Ne ratez aucune demande": "Never miss a request",
  "Niveau": "Level",
  "Nom": "Name",
  "Nom complet": "Full name",
  "Nom de la chambre": "Room name",
  "Nom, téléphone ou email": "Name, phone or email",
  "non approuvée": "not approved",
  "Non précisé": "Not specified",
  "Non précisée": "Not specified",
  "non renseignée": "not provided",
  "non vérifié": "not verified",
  "Non vérifiée": "Not verified",
  "Non-fumeur": "Non-smoker",
  "Non-fumeur. Calme après 22 h. Invités jusqu’à 22 h.": "Non-smoking. Quiet after 10 pm. Guests until 10 pm.",
  "Note globale": "Overall rating",
  "Note interne (optionnel)": "Internal note (optional)",
  "Notification de test envoyée.": "Test notification sent.",
  "Notifications": "Notifications",
  "Notifications activées sur cet appareil.": "Notifications on for this device.",
  "Notifications désactivées sur cet appareil.": "Notifications off for this device.",
  "Notifications push": "Push notifications",
  "Notifications push (tous vos appareils)": "Push notifications (all your devices)",
  "Notifications sur cet appareil": "Notifications on this device",
  "Notre équipe se déplace sous 48 h et active le badge « Visité ».": "Our team visits within 48 h and turns on the “Visited” badge.",
  "Notre équipe vérifie les documents sous 24 à 48 heures.": "Our team checks documents within 24 to 48 hours.",
  "Notre équipe visitera le logement sous 48 h avant publication.": "Our team will visit the place within 48 h before publishing.",
  "Notre équipe visitera le logement sous 48 h avant publication. Vous pouvez continuer à le modifier entre-temps.": "Our team will visit the home within 48 h before publishing. You can keep editing it in the meantime.",
  "Nous envoyons un code à l’adresse email de votre compte.": "We send a code to your account's email address.",
  "Nous n’avons pas pu lire la réponse de la banque. Si le montant a été débité, il sera rapproché automatiquement — sinon réessayez.": "We could not read the bank's answer. If you were charged, it will be reconciled automatically — otherwise try again.",
  "Nous n’avons pas pu valider votre document.": "We couldn't approve your document.",
  "Nous vous enverrons un code par email. Vous pourrez ajouter l’autre rôle plus tard.": "We will email you a code. You can add the other role later.",
  "Nouveau": "New",
  "Nouveau code envoyé.": "New code sent.",
  "Nouveau logement à {city}": "New place in {city}",
  "Nouveau message": "New message",
  "Nouveau mot de passe": "New password",
  "Nouveaux logements": "New places",
  "Nouvel affilié": "New affiliate",
  "Nouvelle adresse vérifiée.": "New address verified.",
  "Nouvelle conversation": "New conversation",
  "Nouvelle demande de réservation": "New booking request",
  "nuit(s)": "night(s)",
  "Nuitée": "Nightly",
  "Nuits min.": "Min. nights",
  "Nuits minimum": "Minimum nights",
  "Numéro ICE (15 chiffres)": "ICE number (15 digits)",
  "Où se trouve le logement ?": "Where is the home?",
  "Oujda": "Oujda",
  "Ouvert aux annonces": "Open for listings",
  "Ouverture…": "Opening…",
  "Ouvrir la messagerie": "Open messages",
  "Ouvrir le menu": "Open the menu",
  "Ouvrir le tableau de bord": "Open the dashboard",
  "Ouvrir sur Bedly": "Open on Bedly",
  "Page introuvable": "Page not found",
  "Paiement": "Payment",
  "Paiement en cours": "Payment in progress",
  "Paiement reçu. Les frais Bedly sont réglés — le loyer se paie en main propre au rendez-vous.": "Payment received. The Bedly fee is paid — the rent is paid in person when you meet.",
  "Paiement refusé": "Payment declined",
  "Paiement refusé par la banque. Rien n’a été débité : vous pouvez réessayer ci-dessous.": "Payment declined by the bank. Nothing was charged: you can try again below.",
  "Par annonce": "By listing",
  "par mois et par personne": "per month, per person",
  "Par sécurité, cette session a été fermée. Reconnectez-vous.": "For your security, this session was closed. Please sign in again.",
  "Paramètres": "Settings",
  "Parking": "Parking",
  "Particulier": "Individual",
  "Pas d’avance en ligne": "No rent paid online",
  "Pas encore d’avis": "No reviews yet",
  "Pas encore d’avis. Les avis sont publiés quand les deux parties ont répondu, ou 14 jours après la fin du séjour.": "No reviews yet. Reviews are published once both sides have replied, or 14 days after the stay ends.",
  "Pas encore de données.": "No data yet.",
  "Pas encore de statistiques": "No statistics yet",
  "Pas encore de visites": "No visits yet",
  "Passées": "Past",
  "Passeport": "Passport",
  "Passer en thème clair": "Switch to light theme",
  "Passer en thème sombre": "Switch to dark theme",
  "Payé en ligne": "Paid online",
  "Payer les frais de service": "Pay the service fee",
  "Payer les frais de service ({amount})": "Pay the service fee ({amount})",
  "Personne ne s’est encore inscrit avec ce code.": "Nobody has signed up with this code yet.",
  "personne(s)": "person(s)",
  "Peu importe": "Any",
  "Photo": "Photo",
  "Photo :": "Photo:",
  "Photo de {city}": "Photo of {city}",
  "Photo de couverture mise à jour.": "Cover photo updated.",
  "Photo floue — le texte est illisible": "Blurry photo — the text can't be read",
  "photo(s)": "photo(s)",
  "photo(s) pour pouvoir publier.": "photo(s) before you can publish.",
  "Photos": "Photos",
  "Photos : Wikimedia Commons, sous licences libres ·": "Photos: Wikimedia Commons, under free licences ·",
  "Photos ou informations insuffisantes": "Not enough photos or information",
  "photos, prises directement au téléphone : chaque pièce, la cuisine, la salle de bain, la vue. La première devient la couverture.": "photos, taken straight on your phone: every room, the kitchen, the bathroom, the view. The first one becomes the cover.",
  "Placez le point sur la carte et indiquez le quartier.": "Place the pin on the map and enter the neighbourhood.",
  "Plus de 7 jours avant": "More than 7 days before",
  "Plus de filtres": "More filters",
  "Plus récentes": "Newest",
  "Plus tard": "Later",
  "Porte blindée": "Security door",
  "Pour la confiance des locataires comme des hôtes. Environ deux minutes.": "For the trust of tenants and hosts alike. About two minutes.",
  "Pour que l’hôte ou le locataire puisse vous joindre. Jamais affiché publiquement.": "So the host or tenant can reach you. Never shown publicly.",
  "Pour recevoir vos revenus d’hôte. Le RIB est transmis au prestataire de paiement et remplacé par un jeton : Bedly n’en garde que les 4 derniers chiffres.": "To receive your host income. The bank details go to the payment provider and are replaced by a token: Bedly only keeps the last 4 digits.",
  "Préférence": "Preference",
  "Préférence de colocation": "Flatmate preference",
  "Préparation…": "Preparing…",
  "Près de": "Near",
  "Près de votre université": "Near your university",
  "Présentez votre logement ou votre recherche…": "Describe your home or what you are looking for…",
  "Présentez-vous": "Introduce yourself",
  "Présentez-vous en deux lignes : études, durée souhaitée, date de visite possible…": "Introduce yourself in two lines: studies, length of stay, when you could visit…",
  "Privée": "Private",
  "Prix & chambres": "Prices & rooms",
  "Prix à venir": "Price coming soon",
  "Prix affiché frais de service inclus. Vous ne payez en ligne que ces frais ; le loyer se règle en espèces à l’hôte lors de la remise des clés.": "Price shown includes the service fee. You only pay that fee online; the rent is paid in cash to the host when the keys are handed over.",
  "Prix croissant": "Price: low to high",
  "Prix décroissant": "Price: high to low",
  "Prix non renseigné": "Price not set",
  "Prix par mois (DH)": "Price per month (MAD)",
  "Prix par nuit (DH)": "Price per night (MAD)",
  "Proche bus": "Near a bus stop",
  "Proche de": "Near",
  "Proche tram": "Near the tram",
  "Profil": "Profile",
  "Profil enregistré.": "Profile saved.",
  "Profil enregistré. Un code a été envoyé à votre nouvelle adresse.": "Profile saved. A code has been sent to your new address.",
  "Profil introuvable": "Profile not found",
  "Proximité du campus": "Closest to campus",
  "Publiées": "Published",
  "Publier": "Publish",
  "Publier l’annonce": "Publish the listing",
  "Publier la demande": "Post the request",
  "Publier un logement": "List a home",
  "Publier une annonce": "Publish a listing",
  "Publier une demande": "Post a request",
  "Publiez chambres, colocations ou nuitées. La publication est gratuite : Bedly prélève une commission uniquement quand une réservation est confirmée.": "List rooms, flatshares or nightly stays. Publishing is free: Bedly only takes a commission when a booking is confirmed.",
  "Publiez gratuitement. Commission de 8 % du premier mois, uniquement si vous êtes réservé.": "Publish for free. 8% commission on the first month, only if you get booked.",
  "Publiez une demande pour que les hôtes et les colocataires vous trouvent.": "Post a request so hosts and flatmates can find you.",
  "Publiez votre première annonce : photos, prix, disponibilités. Dix minutes suffisent.": "Publish your first listing: photos, price, availability. Ten minutes is enough.",
  "Puis-je visiter cette semaine ?": "Can I visit this week?",
  "Quand ?": "When?",
  "Quand emménagez-vous ?": "When are you moving in?",
  "Quartier": "Neighbourhood",
  "Quartier — ajustez si besoin": "Neighbourhood — adjust if needed",
  "Quartier souhaité": "Preferred neighbourhood",
  "Que venez-vous faire sur Bedly ?": "What brings you to Bedly?",
  "Quel type de logement ?": "What type of home?",
  "Quelle adresse est la bonne ?": "Which address is right?",
  "Quelles dates ?": "Which dates?",
  "Quelqu’un répond à votre demande": "Someone replied to your request",
  "Quels équipements ?": "Which amenities?",
  "Rabat": "Rabat",
  "Réactiver": "Reactivate",
  "Recherche libre": "Search",
  "Recherche…": "Searching…",
  "Rechercher": "Search",
  "reçues": "received",
  "Réf.": "Ref.",
  "Référence": "Reference",
  "Référence à indiquer": "Reference to include",
  "Référence de paiement inconnue.": "Unknown payment reference.",
  "Refusée": "Declined",
  "refusée par nos équipes": "rejected by our team",
  "Refuser": "Decline",
  "Refuser cette demande ? Les dates seront libérées.": "Decline this request? The dates will be freed.",
  "Réglé par le locataire": "Paid by the tenant",
  "Régler les frais de service": "Pay the service fee",
  "Règles": "Rules",
  "Règles de la maison": "House rules",
  "Réglez le dépôt pour confirmer votre réservation.": "Pay the service fee to confirm your booking.",
  "Réglez les frais de service pour confirmer votre réservation.": "Pay the service fee to confirm your booking.",
  "Réinitialiser": "Reset",
  "Réinitialiser les filtres": "Reset filters",
  "Rejeter": "Reject",
  "Remboursement des frais": "Fee refund",
  "Remboursement estimé des frais : {amount} ({tier}).": "Estimated fee refund: {amount} ({tier}).",
  "Remettre en ligne": "Put back online",
  "Renvoyée en vérification.": "Sent back for review.",
  "Renvoyer le code": "Resend the code",
  "Répondre à {name}": "Reply to {name}",
  "Répondre à cette demande": "Reply to this request",
  "Répondre à la demande": "Reply to the request",
  "Reprenez les photos en lumière naturelle.": "Retake the photos in natural light.",
  "Réservation annulée": "Booking cancelled",
  "Réservation annulée.": "Booking cancelled.",
  "Réservation confirmée": "Booking confirmed",
  "Réservation introuvable": "Booking not found",
  "réservations": "bookings",
  "Réservations": "Bookings",
  "Réservé": "Booked",
  "Réserver": "Book",
  "Réserver cette chambre": "Book this room",
  "Résoudre": "Resolve",
  "Résultats classés par distance à": "Results sorted by distance to",
  "Retirée": "Removed",
  "Retirer": "Remove",
  "Retirer cette photo": "Remove this photo",
  "Retirer cette vidéo": "Remove this video",
  "Retirer des favoris": "Remove from saved",
  "Retour": "Back",
  "Retour à l’accueil": "Back to home",
  "Retour à la connexion": "Back to sign in",
  "Retour à mon compte": "Back to my account",
  "Retour aux résultats": "Back to results",
  "Revenus": "Earnings",
  "Revenus attendus": "Expected earnings",
  "Revenus confirmés": "Confirmed earnings",
  "RIB (24 chiffres)": "RIB (24 digits)",
  "RIB Bedly · sous 24 h ouvrées": "Bedly bank transfer · within 24 working hours",
  "RIB enregistré. Seuls les 4 derniers chiffres sont conservés.": "Bank details saved. Only the last 4 digits are kept.",
  "Rien à faire": "Nothing to do",
  "Rôles": "Roles",
  "Rue — ajustez si besoin": "Street — adjust if needed",
  "S’inscrire": "Sign up",
  "Saisir les coordonnées à la main": "Enter coordinates by hand",
  "Salé": "Salé",
  "Salle de bain dans la chambre": "En-suite bathroom",
  "Salle de bain partagée": "Shared bathroom",
  "Salle de bain privée": "Private bathroom",
  "salle(s) de bain": "bathroom(s)",
  "Salles de bain": "Bathrooms",
  "Salma El Amrani": "Salma El Amrani",
  "Sam": "Sat",
  "Se connecter": "Sign in",
  "Se déconnecter": "Sign out",
  "Se déconnecter partout": "Sign out everywhere",
  "se règle en espèces directement à l’hôte lors de la remise des clés.": "is paid in cash directly to the host when the keys are handed over.",
  "Sections": "Sections",
  "Sécurité": "Security",
  "Séjour minimum :": "Minimum stay:",
  "Séjour terminé": "Stay completed",
  "Séjours confirmés": "Confirmed stays",
  "Selfie effectué": "Selfie done",
  "Selfie fourni": "Selfie provided",
  "Selfie manquant": "Selfie missing",
  "Session de vérification ouverte.": "Verification session opened.",
  "Seules les images et les vidéos sont acceptées.": "Only images and videos are accepted.",
  "Si cette adresse a un compte, un code vient d’être envoyé.": "If this address has an account, a code has just been sent.",
  "Si un partenaire de Bedly vous a donné un code.": "If a Bedly partner gave you a code.",
  "Signalé par": "Reported by",
  "Signalement rejeté.": "Report dismissed.",
  "Signalement résolu.": "Report resolved.",
  "Signalements": "Reports",
  "Signalements ouverts": "Open reports",
  "Société / agence immobilière": "Company / estate agency",
  "Soyez prévenu sur ce téléphone ou cet ordinateur : nouvelle demande, réservation confirmée, nouveau message — même quand Bedly est fermé.": "Get told on this phone or computer: new request, confirmed booking, new message — even when Bedly is closed.",
  "Statistiques": "Statistics",
  "Statut": "Status",
  "Statut : {status}": "Status: {status}",
  "Statut de l’annonce": "Listing status",
  "Suivant": "Next",
  "Supprimer": "Delete",
  "Supprimer définitivement": "Delete permanently",
  "Supprimer mon compte": "Delete my account",
  "Supprimer votre compte ?": "Delete your account?",
  "sur {count} jours": "over {count} days",
  "sur 3 —": "of 3 —",
  "Sur iPhone : touchez Partager, puis « Sur l’écran d’accueil ». Ouvrez Bedly depuis la nouvelle icône et activez les notifications.": "On iPhone: tap Share, then “Add to Home Screen”. Open Bedly from the new icon and turn on notifications.",
  "Survolez une barre pour le détail": "Hover over a bar for details",
  "Suspendre": "Suspend",
  "Suspendre {name} ?": "Suspend {name}?",
  "Suspendu": "Suspended",
  "Ta chambre au Maroc, en 2 minutes": "Your room in Morocco, in 2 minutes",
  "Tableau de bord": "Dashboard",
  "Tableau de bord hôte": "Host dashboard",
  "Tâches de maintenance": "Maintenance tasks",
  "Tâches exécutées.": "Tasks run.",
  "Tanger": "Tangier",
  "Tarif enregistré.": "Price saved.",
  "Taxes incluses": "Taxes included",
  "Téléphone": "Phone",
  "Téléphone (optionnel)": "Phone (optional)",
  "Temps réel actif": "Live updates on",
  "Terminée": "Completed",
  "Tétouan": "Tetouan",
  "Thème clair": "Light theme",
  "Thème sombre": "Dark theme",
  "Titre": "Title",
  "Titre de l’annonce": "Listing title",
  "Titulaire": "Holder",
  "Titulaire du compte": "Account holder",
  "Total du séjour": "Total for the stay",
  "Touchez le cœur sur une annonce pour la retrouver ici.": "Tap the heart on a listing to find it here.",
  "Touchez une date de début puis une date de fin pour bloquer une période. Les nuits réservées ne peuvent pas être libérées depuis ici — ce serait survendre la chambre.": "Tap a start date then an end date to block a period. Booked nights cannot be released from here — that would double-sell the room.",
  "Tous": "All",
  "Tous les filtres": "All filters",
  "Tout est prêt. L’annonce passera en revue avant publication.": "All set. The listing will be reviewed before it goes live.",
  "Tout marqué comme lu.": "All marked as read.",
  "Tout marquer comme lu": "Mark all as read",
  "Toutes": "All",
  "Toutes les villes": "All cities",
  "Trier par": "Sort by",
  "Trop de codes erronés — demandez-en un nouveau.": "Too many wrong codes — ask for a new one.",
  "Trop de tentatives. Réessayez dans quelques minutes.": "Too many attempts. Try again in a few minutes.",
  "Trouvé — clôturée": "Found — closed",
  "Trouvez votre chambre au Maroc": "Find your room in Morocco",
  "Type": "Type",
  "Type de location": "Rental type",
  "Type de séjour": "Type of stay",
  "Types de location proposés": "Rental types offered",
  "UM5-2026": "UM5-2026",
  "UM5, UM6P…": "UM5, UM6P…",
  "Un avis a été publié": "A review was published",
  "Un compte existe déjà avec ce numéro de téléphone.": "An account already exists with this phone number.",
  "Un compte existe déjà avec cet email.": "An account already exists with this email.",
  "Un compte société doit indiquer son numéro ICE à 15 chiffres.": "A business account needs its 15-digit ICE number.",
  "Un email universitaire en .ac.ma accélère la vérification étudiante.": "A university email ending in .ac.ma speeds up student verification.",
  "Un lit dans une chambre commune": "A bed in a shared room",
  "Un numéro ICE compte exactement 15 chiffres.": "An ICE number is exactly 15 digits.",
  "Un paiement est nécessaire pour continuer.": "A payment is needed to continue.",
  "Un prix et une durée minimale pour chaque type de location choisi à l’étape précédente.": "A price and a minimum length for each rental type chosen in the previous step.",
  "Un RIB marocain compte exactement 24 chiffres.": "A Moroccan RIB is exactly 24 digits.",
  "Un séjour à la nuit demande une date de départ.": "A nightly stay needs a check-out date.",
  "Un séjour compte au moins une nuit.": "A stay must be at least one night.",
  "Un selfie rapide pour confirmer que c’est bien vous": "A quick selfie to confirm it is really you",
  "Un service externe ne répond pas. Réessayez dans un instant.": "An external service isn't responding. Try again in a moment.",
  "Une annonce peut contenir {max} photos au maximum.": "A listing can have at most {max} photos.",
  "Une annonce peut contenir {max} vidéos au maximum.": "A listing can have at most {max} videos.",
  "Une annonce supprimée ne peut plus être modifiée.": "A deleted listing can't be changed.",
  "Une chambre dans un logement partagé": "A room in a shared home",
  "Une demande privée n’apparaît pas dans le fil : vous seul la voyez.": "A private request does not appear in the feed: only you can see it.",
  "Une erreur est survenue": "Something went wrong",
  "Une vérification est déjà en cours.": "A verification is already in progress.",
  "Unité": "Unit",
  "Université": "University",
  "Université (optionnel)": "University (optional)",
  "Université Abdelmalek Essaâdi": "Abdelmalek Essaâdi University",
  "Université Cadi Ayyad": "Cadi Ayyad University",
  "Université Hassan II — ENCG": "Hassan II University — ENCG",
  "Université Ibn Tofaïl": "Ibn Tofail University",
  "Université Ibn Zohr": "Ibn Zohr University",
  "Université Mohammed Premier": "Mohammed First University",
  "Université Mohammed V": "Mohammed V University",
  "Université Mohammed VI Polytechnique": "Mohammed VI Polytechnic University",
  "Université Moulay Ismaïl": "Moulay Ismail University",
  "Université Sidi Mohamed Ben Abdellah": "Sidi Mohamed Ben Abdellah University",
  "Utilisateur": "User",
  "Utilisateur supprimé": "Deleted user",
  "Utilisateurs": "Users",
  "Valeur invalide.": "Invalid value.",
  "Ven": "Fri",
  "Vérification": "Verification",
  "Vérification d’identité": "Identity verification",
  "Vérification en cours. Notre équipe répond sous 24 à 48 h et vous recevrez une notification.": "Verification in progress. Our team answers within 24 to 48 h and you will get a notification.",
  "Vérification refusée": "Verification rejected",
  "Vérification refusée.": "Verification declined.",
  "Vérification…": "Verifying…",
  "vérifié": "verified",
  "Vérifié": "Verified",
  "Vérifiée": "Verified",
  "Vérifier": "Verify",
  "Vérifier maintenant": "Verify now",
  "Vérifier mon email": "Verify my email",
  "Vérifier mon identité": "Verify my identity",
  "Vérifier votre identité": "Verify your identity",
  "Vérifiés": "Verified",
  "Vérifiez votre adresse email auprès de Google avant de vous connecter avec.": "Verify your email address with Google before signing in with it.",
  "Vérifiez votre adresse email avant d’envoyer des messages.": "Verify your email address before sending messages.",
  "Vérifiez votre adresse email avant de réserver.": "Verify your email address before booking.",
  "Vérifiez votre adresse email.": "Verify your email address.",
  "Vérifiez votre email": "Verify your email",
  "Versements sécurisés par RIB": "Secure payouts by bank transfer",
  "Vidéo trop lourde : {max} Mo maximum. Filmez plus court ou en 720p.": "Video too large: {max} MB maximum. Film a shorter clip or in 720p.",
  "Vidéos": "Videos",
  "Vidéos (facultatif)": "Videos (optional)",
  "Ville": "City",
  "Villes": "Cities",
  "villes couvertes": "cities covered",
  "villes. Aucune chambre n’est encore en ligne — si vous avez une chambre, une colocation ou un logement à louer, vous pouvez être le premier.": "cities. No rooms are online yet — if you have a room, a flatshare or a home to rent, you can be the first.",
  "Virement bancaire": "Bank transfer",
  "Visa, Mastercard — débit immédiat sécurisé": "Visa, Mastercard — secure instant payment",
  "Visible dans le fil public": "Visible in the public feed",
  "Visité": "Visited",
  "Visité par Bedly": "Visited by Bedly",
  "Visitée par Bedly.": "Visited by Bedly.",
  "visiteurs uniques": "unique visitors",
  "Voir": "View",
  "Voir {count} logements": "See {count} places",
  "Voir 1 logement": "See 1 place",
  "Voir l’annonce": "View the listing",
  "Voir l’original sur Wikimedia Commons": "See the original on Wikimedia Commons",
  "Voir la réservation": "View the booking",
  "Voir le tableau de bord": "View the dashboard",
  "Voir les inscrits": "See signups",
  "Voir tout": "See all",
  "Vos annonces": "Your listings",
  "Vos coordonnées": "Your details",
  "Vos documents sont envoyés directement au prestataire de vérification. Bedly n’en conserve que la référence et le résultat — jamais l’image.": "Your documents go straight to the verification provider. Bedly only keeps the reference and the result — never the image.",
  "Vos informations": "Your information",
  "Vos prochaines réservations apparaîtront ici.": "Your upcoming bookings will appear here.",
  "vos vidéos ne doivent contenir": "your videos must contain",
  "Votre annonce est visible par les étudiants.": "Your listing is visible to students.",
  "Votre avis": "Your review",
  "Votre avis est enregistré.": "Your review is saved.",
  "Votre avis reste masqué jusqu’à ce que l’autre partie réponde, ou 14 jours après la fin du séjour. Personne ne peut lire le vôtre avant d’écrire le sien.": "Your review stays hidden until the other side replies, or 14 days after the stay ends. Nobody can read yours before writing theirs.",
  "Votre avis sera publié quand l’autre partie aura répondu, ou après 14 jours.": "Your review will be published when the other side replies, or after 14 days.",
  "Votre CNIE, passeport ou carte de séjour": "Your national ID, passport or residence permit",
  "Votre commentaire": "Your comment",
  "Votre compte n’a pas accès à cette action.": "Your account can't do this.",
  "Votre dépôt est bloqué par Bedly jusqu’au check-in. L’adresse exacte est débloquée.": "Your booking is confirmed. The exact address is now unlocked.",
  "Votre email est vérifié : vous pouvez réserver, publier et écrire aux hôtes.": "Your email is verified: you can book, publish and message hosts.",
  "Votre identité doit d’abord être vérifiée.": "Your identity needs to be verified first.",
  "Votre identité est déjà vérifiée.": "Your identity is already verified.",
  "Votre identité n’est pas encore vérifiée. Vous pouvez réserver, mais la vérification rassure les hôtes et accélère les acceptations.": "Your identity is not verified yet. You can book, but verification reassures hosts and speeds up acceptances.",
  "Votre mot de passe actuel n’est pas correct.": "Your current password isn't right.",
  "Votre numéro de téléphone n’est jamais affiché. Les échanges passent par la messagerie Bedly.": "Your phone number is never shown. Conversations go through Bedly messaging.",
  "Votre prix en entier, en espèces, sans commission": "Your full price, in cash, no commission",
  "votre prix, en espèces": "your price, in cash",
  "Votre profil est anonymisé et vos annonces retirées. Les réservations et avis dont d’autres personnes dépendent sont conservés sans votre nom. Cette action est irréversible.": "Your profile is anonymised and your listings removed. Bookings and reviews other people depend on are kept without your name. This cannot be undone.",
  "Votre réservation est confirmée. L’adresse exacte est maintenant visible.": "Your booking is confirmed. The exact address is now visible.",
  "Votre session a expiré. Reconnectez-vous.": "Your session has expired. Please sign in again.",
  "Vous avez déjà 3 demandes actives — mettez-en une en pause d’abord.": "You already have 3 active requests — pause one first.",
  "Vous avez déjà laissé un avis sur ce séjour.": "You've already reviewed this stay.",
  "Vous avez une chambre libre ?": "Have a spare room?",
  "Vous êtes": "You are",
  "Vous êtes déjà hôte.": "You are already a host.",
  "Vous n’avez pas répondu à la demande {reference} à temps ; elle a expiré.": "You didn't reply to request {reference} in time; it has expired.",
  "Vous ne pouvez pas faire cela.": "You can't do that.",
  "Vous ne pouvez pas réserver votre propre logement.": "You can't book your own place.",
  "Vous ne pouvez pas vous écrire à vous-même.": "You can't message yourself.",
  "Vous pourrez laisser un avis une fois le séjour terminé.": "You can leave a review once the stay is over.",
  "Vous pouvez désactiver ces emails dans Paramètres → Notifications.": "You can turn these emails off in Settings → Notifications.",
  "Vous recevez, en espèces": "You receive, in cash",
  "Vous réglez uniquement les frais de service Bedly. Le loyer se paie en espèces à l’hôte, à la remise des clés.": "You only pay the Bedly service fee online. The rent is paid in cash to the host when you get the keys.",
  "Vous serez prévenu ici des demandes, réservations et messages.": "You'll be told here about requests, bookings and messages.",
  "Vous vous connectez avec Google. Pour ajouter aussi un mot de passe, utilisez « Mot de passe oublié » sur l’écran de connexion : le code arrivera à votre adresse Gmail.": "You sign in with Google. To add a password as well, use “Forgot your password?” on the sign-in screen: the code will arrive at your Gmail address.",
  "vous@exemple.ma": "you@example.com",
  "vous@exemple.ma ou 06 12 34 56 78": "you@example.com or 06 12 34 56 78",
  "voyageur(s)": "guest(s)",
  "Voyageurs": "Guests",
  "Voyageurs max": "Max guests",
  "Vue carte": "Map view",
  "Vue liste": "List view",
  "Vues": "Views",
  "Vues et demandes": "Views and requests",
  "Wafacash / Cash Plus": "Wafacash / Cash Plus",
  "WhatsApp": "WhatsApp",
  "Wi-Fi": "Wi-Fi",
  "Wi-Fi fibre": "Fibre Wi-Fi",
  "العربية": "العربية",
};
